export enum LinkAccessTypeEnum {
  PUBLIC = 'public',

  LOGGED_IN_USER = 'logged-in-user',

  SPECIFIC_USER = 'specific-user',
}

export enum AssetLinkTypeEnum {
  PRODUCT = 'product',

  COLLECTION = 'collection',
}
